import { z } from "zod";
import { marketSchema } from "../schemas/index.js";
export class MarketsResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /** Market types available on a specific contest. */
    contestMarkets(contestId) {
        return this.http.request({
            method: "GET",
            path: `/contests/${encodeURIComponent(contestId)}/markets`,
            endpoint: "markets.contestMarkets",
            dataSchema: z.array(marketSchema),
        });
    }
    /** A market definition (not contest-specific). */
    get(marketId) {
        return this.http.request({
            method: "GET",
            path: `/markets/${encodeURIComponent(marketId)}`,
            endpoint: "markets.get",
            dataSchema: marketSchema,
        });
    }
}
//# sourceMappingURL=markets.js.map